import gql from 'graphql-tag'

export default gql`
mutation createArticle($input: ArticleInput) {
  createArticle(input: $input) {
    id
    header_desktop
    header_mobile
    img_featured_desktop
    img_featured_mobile
    article_date
    author {
      id
    }
    category {
      id
    }
    details {
      id
      title
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/article/create.js